import { render, staticRenderFns } from "./setElementPosition.vue?vue&type=template&id=629d0914&scoped=true&"
import script from "./setElementPosition.vue?vue&type=script&lang=js&"
export * from "./setElementPosition.vue?vue&type=script&lang=js&"
import style0 from "./setElementPosition.vue?vue&type=style&index=0&id=629d0914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629d0914",
  null
  
)

export default component.exports